import { Timeline } from "antd";
import "./timeline_comp.scss";

const Data = [
  {
    date: "2024-05-22",
    title: "Published",
  },
  {
    date: "2024-05-19",
    title: "Created and Scheduled",
    description: "Scheduled for 2024-05-22",
  },
];

const ArticleTimeline = ({ timelineData = Data }) => {
  return (
    <Timeline className="timeline-comp">
      {timelineData.map((item, index) => (
        <Timeline.Item key={index}>
          <div className="data-container">
            <h6 className="date-data">{item?.date}</h6>
            <div className="details-container">
              <h4 className="data-title">{item?.status_remarks}</h4>
              {item.reason && <h5 className="data-desc">{item?.reason}</h5>}
            </div>
          </div>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default ArticleTimeline;
